import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/blogs.constants';
import { getAll, getOne, save, softDelete } from 'services/blogs.services';

export function* blogsDelete(action: AnyAction): Generator {
  try {
    const { id }: any = action;
    const { data }: any = yield call(softDelete, id);
    yield put({
      type: constants.BLOGS_ON_DELETE_SUCCEEDED,
      data: { ...data, id },
    });
  } catch (error) {
    yield put({ type: constants.BLOGS_ON_DELETE_FAILED, error });
  }
}

export function* blogsGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({ type: constants.BLOGS_ON_GET_ALL_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.BLOGS_ON_GET_ALL_FAILED, error });
  }
}

export function* blogsGetOne(action: AnyAction): Generator {
  try {
    const { id }: any = action;
    if (id) {
      const { data }: any = yield call(getOne, id);
      yield put({ type: constants.BLOGS_ON_GET_ONE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.BLOGS_ON_GET_ONE_FAILED, error });
  }
}

export function* blogsSave(action: AnyAction): Generator {
  try {
    const { formData, id } = action;
    const { data }: any = yield call(save, formData, id);
    yield put({ type: constants.BLOGS_ON_SAVE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.BLOGS_ON_SAVE_FAILED, error });
  }
}

export function* blogsRefresh(): Generator {
  const table: any = yield select((state) => state.blogs.table);
  yield put({ type: constants.BLOGS_ON_GET_ALL_REQUESTED, ...table });
}

export function* watchBlogs(): Generator {
  yield all([
    takeLatest(constants.BLOGS_ON_DELETE_REQUESTED, blogsDelete),
    takeLatest(constants.BLOGS_ON_GET_ALL_REQUESTED, blogsGetAll),
    takeLatest(constants.BLOGS_ON_GET_ONE_REQUESTED, blogsGetOne),
    takeLatest(constants.BLOGS_ON_SAVE_REQUESTED, blogsSave),
    takeLatest(
      [constants.BLOGS_ON_DELETE_SUCCEEDED, constants.BLOGS_ON_SAVE_SUCCEEDED],
      blogsRefresh,
    ),
  ]);
}
